<template>
  <section class="py-8 bg-gray-50 dark:bg-gray-900/50">
    <div class="max-w-7xl mx-auto px-4">
      <h2
        class="text-2xl font-bold text-center text-gray-900 dark:text-white mb-8"
      >
        Browse by Event Types
      </h2>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <NuxtLink
          v-for="type in types.data"
          :key="type.id"
          :to="`/events?types=${type.id}`"
          class="flex-none bg-white dark:bg-gray-800 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
        >
          <div class="p-4 md:p-6">
            <!-- Icon Circle -->
            <div
              class="w-10 h-10 md:w-12 md:h-12 bg-primary rounded-full flex items-center justify-center mb-3 md:mb-4"
            >
              <Icon
                :name="getIconForType(type.attributes.slug)"
                class="w-5 h-5 md:w-6 md:h-6 text-white"
              />
            </div>

            <!-- Content -->
            <div class="space-y-1.5">
              <h3
                class="text-base md:text-lg font-semibold text-gray-900 dark:text-white mb-1 md:mb-2 line-clamp-1"
              >
                {{ type.attributes.title }}
              </h3>
            </div>
          </div>
        </NuxtLink>
      </div>
    </div>
  </section>
</template>

<style scoped>
.animate-fade-in {
  animation: fadeIn 0.6s ease-out;
}

.animate-slide-down {
  animation: slideDown 0.6s ease-out;
}

.animate-fade-in-up {
  animation: fadeInUp 0.6s ease-out;
}

.animate-fade-scale-up {
  animation: fadeScaleUp 0.5s ease-out forwards;
  opacity: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeScaleUp {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>

<script setup>
// Define icons mapping for different types
const typeIcons = {
  conference: "heroicons:presentation-chart-bar",
  exhibitions: "heroicons:photo",
  workshop: "heroicons:academic-cap",
  CCFS: "heroicons:document-text",
  Symp: "heroicons:user-group",
  cds: "heroicons:arrow-path",
};

// Function to get icon based on type
const getIconForType = (slug) => typeIcons[slug] || "heroicons:squares-2x2";

// Mock data (replace with actual API call)
const types = {
  data: [
    {
      id: 2,
      attributes: {
        title: "Exhibitions",
        slug: "exhibitions",
        value: 5,
        description:
          "“Exhibition” refers to projects, presentations, or products through which they have learned, usually as a way or demonstration whether and to what degree they have achieved expected learning standards or learning objectives.",
        createdAt: "2024-09-02T00:19:35.521Z",
        updatedAt: "2024-09-02T00:19:39.796Z",
        publishedAt: "2024-09-02T00:19:39.591Z",
      },
    },
    {
      id: 1,
      attributes: {
        title: "Conference",
        slug: "conference",
        value: 1,
        description:
          "An academic conference or scientific conference (also congress, symposium, workshop, or meeting) is an event for researchers to present and discuss their scholarly work.",
        createdAt: "2024-09-02T00:17:59.675Z",
        updatedAt: "2024-09-02T00:21:31.861Z",
        publishedAt: "2024-09-02T00:18:04.922Z",
      },
    },
    {
      id: 5,
      attributes: {
        title: "Certificate Courses and Fellowships",
        slug: "CCFS",
        value: null,
        description: null,
        createdAt: "2024-09-04T03:02:58.515Z",
        updatedAt: "2024-09-04T03:03:03.426Z",
        publishedAt: "2024-09-04T03:03:03.258Z",
      },
    },
    {
      id: 3,
      attributes: {
        title: "Workshops and Training Programs",
        slug: "workshop",
        value: 3,
        description:
          "Workshop is a short-term academic event, where a small group of people meet to get acquainted and discuss new concepts, skills or new practices",
        createdAt: "2024-09-02T00:20:42.229Z",
        updatedAt: "2024-09-07T11:30:16.239Z",
        publishedAt: "2024-09-02T00:20:46.323Z",
      },
    },
    {
      id: 6,
      attributes: {
        title: "Symposium, Conclave, Seminar",
        slug: "Symp",
        value: null,
        description: null,
        createdAt: "2024-09-04T16:12:08.958Z",
        updatedAt: "2024-12-04T00:24:38.677Z",
        publishedAt: "2024-09-04T16:12:13.113Z",
      },
    },
    {
      id: 4,
      attributes: {
        title: "Continuing Development Programs",
        slug: "cds",
        value: null,
        description: null,
        createdAt: "2024-09-03T15:27:19.089Z",
        updatedAt: "2025-04-09T01:48:19.536Z",
        publishedAt: "2024-09-03T15:27:29.008Z",
      },
    },
  ],
};
</script>
